module.exports = __webpack_public_path__ + "static/media/tarjeta-oro-bloque.28fb1bfb.png";